import showreelMp4FilePath from "../../assets/files/tenderhub-page/showreel.mp4";
import showreelWebmFilePath from "../../assets/files/tenderhub-page/showreel.webm";
import "./showreel-page.sass";

const ShowreelPage = () => {
  return (
    <div className="page showreel-page">
      <video
        className="showreel-page__video"
        controls
        preload="auto"
        playsInline
      >
        {/* order matters: browser will pick the first supported format */}
        <source src={showreelWebmFilePath} type="video/webm" />
        <source src={showreelMp4FilePath} type="video/mp4" />
      </video>
    </div>
  );
};

export default ShowreelPage;
